import React from 'react';
import { 
  Chip,
  Grid,
  List, 
  ListItem, 
  ListItemButton, 
  ListItemIcon,
  ListItemText,
  useTheme,
} from "@mui/material";
import { useAuth0 } from '@auth0/auth0-react';
import { navigationOptions } from "./menuOptions";
import { Link, useNavigate } from 'react-router-dom';
import gtmTrackButtonClick from '../../libs/gtmTrackButtonClick';
import LogoutIcon from '@mui/icons-material/Logout';


function DesktopUserFlowNav({
  open,
  userInfo
}){

  const theme = useTheme();
  const navigate = useNavigate();
	const { logout, isAuthenticated } = useAuth0();

  const RenderSubscriptionTier = () => {

    switch(userInfo?.stripeProductId){
      case null || undefined :{
        return (
          <Chip 
            label="BASIC FREE" 
            color="primary"
            sx={{ padding: '0 2rem'}} 
            variant='outlined'
            onClick={() => navigate('/subscriptions')}
          />
        )
      }
      case `${process.env.REACT_APP_SUB_TIER_PLUS}`:{
        return (
          <Chip 
            label="PLUS MEMBER" 
            color="primary"
            variant='outlined'
            sx={{ padding: '0 2rem'}} 
            onClick={() => navigate('/subscriptions')}
          />
        )
      };
      case `${process.env.REACT_APP_SUB_TIER_PREMIUM}`:{
        return (
          <Chip 
            label="PREMIUM MEMBER" 
            color="primary"
            sx={{ padding: '0 1rem'}} 
            variant='outlined'
            onClick={() => navigate('/subscriptions')}
          />
        )
      };
      default: return null;
    }
  };

  const RenderListItemButton = ({option}) => {
    const isExternal = option.link.startsWith('http');
    const ListItemComponent = isExternal ? 'a' : Link;

    return (
      <ListItem
				disablePadding
				component={ListItemComponent}
				to={isExternal ? undefined : option.link}
				href={isExternal ? option.link : undefined}
				target={isExternal ? '_blank' : undefined}
				rel={isExternal ? 'noopener noreferrer' : undefined}
				sx={{ 
					display: 'block', 
					flex: '1',
					borderColor: `${theme.palette.grays.md}`,
					borderWidth: '1px',
					margin: '0 16px', 
					width: '85%',
					padding: '0.5rem 0'
				}}
				key={option?.id}
				divider
			>
				<ListItemButton
					onClick={(e) => {
						gtmTrackButtonClick(e, option.analyticId);
					}}
					sx={{
						minHeight: 48,
						justifyContent: open ? 'initial' : 'center',
						px: 2.5,
						height: '100%'
					}}
				>
					<ListItemIcon
						sx={{
							minWidth: 0,
							mr: open ? 3 : 'auto',
							justifyContent: 'center',
						}}
					>
						{option?.icon({ color: `${theme.palette.primary.main}`})}
					</ListItemIcon>
					<ListItemText 
						primary={option?.name} 
						sx={{ 
							opacity: open ? 1 : 0, 
							fontFamily: `${theme.typography.secondary.fontFamily}`, 
							color: `${theme.palette.grays.dk}`
						}} 
					/>
				</ListItemButton>
			</ListItem>
    );
  };

  return (
    <Grid 
      container 
      sx={{
        display: 'flex',
        flexDirection: 'column', 
        width: '100%',
        height: '100vh',
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      <Grid 
        item 
        sx={{
          flex: 1,
          width: '100%'
        }}
      >
        <List 
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            padding: 0
          }}
        >
          { navigationOptions.map((option) => (
            <RenderListItemButton option={option} />
          ))}
          {/* Admin section */}
          { isAuthenticated && (
						<ListItem 
							disablePadding 
							sx={{ 
								display: 'block', 
								flex: '1',
								borderColor: `${theme.palette.grays.md}`,
								borderWidth: '1px',
								margin: '0 16px', 
								width: '85%',
								padding: '0.5rem 0'
							}}
							component={Link}
							divider
							button
						>
							<ListItemButton 
								color="secondary" 
								onClick={() => logout({
									logoutParams: { returnTo: window.location.origin } 
								})}
								sx={{
									minHeight: 48,
									justifyContent: open ? 'initial' : 'center',
									px: 2.5,
									height: '100%'
								}}
							>
								<ListItemIcon
									sx={{
										minWidth: 0,
										mr: open ? 3 : 'auto',
										justifyContent: 'center',
									}}
								>
									<LogoutIcon sx={{ color: 'red' }} />
								</ListItemIcon>
								<ListItemText 
									primary={'Log Out'} 
									sx={{ 
										opacity: open ? 1 : 0, 
										fontFamily: `${theme.typography.secondary.fontFamily}`, 
										color: `red`
									}} 
								/>
							</ListItemButton>
						</ListItem>
					)}
        </List>
      </Grid>

      {/* Subscription tier at bottom */}
      {/* <Grid 
        item 
        sx={{
          width: '100%',
          mt: 'auto', // Push to bottom
          borderTop: '1px solid rgba(255, 255, 255, 0.12)', // Optional divider
          backgroundColor: 'inherit',
          ml: '1rem',
          mb: '1rem'
        }}
      >
        {open && <RenderSubscriptionTier />}
      </Grid> */}
    </Grid>
  );
};

export default DesktopUserFlowNav;